import type { Dayjs } from 'dayjs'

export const BACKEND_TIMESTAMP_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export const toBackendTimestamp = (value?: Dayjs | null) =>
  value?.isValid() ? value.format(BACKEND_TIMESTAMP_FORMAT) : undefined
